import { css } from '@emotion/react'
import { FC } from 'react'

import Button from '~/form/components/atoms/Button'
import IconButton from '~/form/components/molecules/IconButton'
import { FormState } from '~/form/redux/formSlice'

type Props = {
  isLoading: boolean
  page: FormState['page']
  onBack: () => void
}

const FormButtonSet: FC<Props> = ({ page, onBack, isLoading }) => {
  if (!page) return null

  return (
    <div css={buttonSetWrapper}>
      {page === 'input' && <Button type='submit'>内容を確認</Button>}
      {page === 'confirm' && (
        <>
          <Button type='button' onClick={onBack} outline={true}>
            戻る
          </Button>
          <IconButton type='submit' icon='send' disabled={isLoading}>
            内容を送信
          </IconButton>
        </>
      )}
    </div>
  )
}

export default FormButtonSet

const buttonSetWrapper = css`
  display: flex;
  justify-content: center;
  gap: 20px;
`
